import React from 'react';
import { Card, CardContent } from '../ui/card';
import { CheckCircle, Star, FileText, TestTube, DollarSign, Award, Phone, Shield } from 'lucide-react';

const RequirementsSection = () => {
  const requirements = [
    {
      icon: Shield,
      title: "Be honest about your position",
      priority: "essential"
    },
    {
      icon: TestTube,
      title: "Provide the most recent assay reports",
      priority: "essential"
    },
    {
      icon: FileText,
      title: "Indicate your refinery partner",
      priority: "essential"
    },
    {
      icon: DollarSign,
      title: "Clarify collateral availability",
      priority: "essential"
    },
    {
      icon: Award,
      title: "Own a valid export license",
      priority: "essential"
    },
    {
      icon: TestTube,
      title: "Accept testing before payment",
      priority: "essential"
    },
    {
      icon: Phone,
      title: "Be reachable and responsive",
      priority: "essential"
    }
  ];

  const bonusRequirement = {
    icon: Star,
    title: "Minimum 96% purity",
    priority: "bonus"
  };

  return (
    <section id="requirements" className="py-24 bg-[#040F2D]">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8">
        <div className="text-center mb-20">
          <h2 className="text-5xl font-bold text-white mb-6">Our Requirements</h2>
          <p className="text-xl text-white/70 max-w-3xl mx-auto">
            Essential criteria for a successful partnership with us
          </p>
        </div>

        <div className="grid md:grid-cols-2 lg:grid-cols-3 xl:grid-cols-4 gap-4 mb-12">
          {requirements.map((requirement, index) => {
            const IconComponent = requirement.icon;
            return (
              <Card key={index} className="border border-white/10 hover:border-[#D4AF37]/50 transition-all duration-300 bg-[#0B132B]/60 shadow-sm hover:shadow-md">
                <CardContent className="p-4">
                  <div className="flex items-center space-x-3">
                    <div className="w-8 h-8 bg-[#040F2D]/10 rounded-lg flex items-center justify-center flex-shrink-0">
                      <IconComponent className="h-4 w-4 text-white" />
                    </div>
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-semibold text-white leading-tight">
                        {requirement.title}
                      </p>
                    </div>
                    <CheckCircle className="h-4 w-4 text-green-500 flex-shrink-0" />
                  </div>
                </CardContent>
              </Card>
            );
          })}
        </div>

        {/* Commodities Requirement */}
        <div className="max-w-md mx-auto">
          <Card className="border-2 border-[#D4AF37]/30 bg-gradient-to-br from-[#D4AF37]/5 to-[#C5A059]/5 shadow-lg">
            <CardContent className="p-6 text-center">
              <div className="w-12 h-12 bg-[#D4AF37] rounded-full flex items-center justify-center mx-auto mb-4">
                <Star className="h-6 w-6 text-white" />
              </div>
              <h3 className="text-lg font-bold text-white mb-2">
                Commodities Requirement
              </h3>
              <p className="text-[#0B132B] font-medium">
                {bonusRequirement.title}
              </p>
            </CardContent>
          </Card>
        </div>

        <div className="mt-16 text-center">
          <div className="bg-gradient-to-r from-[#040F2D]/5 to-[#0B132B]/5 rounded-xl p-6 border border-[#D4AF37]/20">
            <p className="text-lg text-white font-semibold">
              Ready to apply? Start your verification process below.
            </p>
            <button
              onClick={() => document.getElementById('application').scrollIntoView({ behavior: 'smooth' })}
              className="bg-[#D4AF37] hover:bg-[#C5A059] text-white px-6 py-3 rounded-lg font-semibold transition-all transform hover:scale-105 mt-4"
            >
              Start Application
            </button>
          </div>
        </div>
      </div>
    </section>
  );
};

export default RequirementsSection;